import { LANGAUAGE_PRIORITY } from '@constants/global';
import { Translations } from '@domain/admission';

export const getDynamicPlaceholder = (defaultTranslation: string, translationsObj?: Translations): string => {
  if (!translationsObj) return defaultTranslation;

  const filteredLang =
    LANGAUAGE_PRIORITY.find((langPriorized) => {
      if (translationsObj[langPriorized]) return translationsObj[langPriorized];
      return false;
    }) ?? 'en';

  return translationsObj[filteredLang] ?? defaultTranslation;
};
